export const OPERATION_FAILED = 'OperationFailed';
export const CLEAR_FAILED_OPERATION = 'CLEAR_FAILED_OPERATION';
